import { Component } from '@angular/core';

@Component({
  selector: 'espace-commissionnement-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
})
export class ErrorComponent {}
